import styled from 'styled-components';
import { WHITE } from '../../../utils/colours';


export const IconButtonContainer = styled.button`
    width: 40px;
    height: 40px;
    background: ${({ $defaultBackgroundColour }) => $defaultBackgroundColour ?? 'none'};
    border: none;
    padding: 0;
    border-radius: 40px;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: ${({ $colour }) => $colour ?? WHITE()};

    svg {
        width: auto;
        height: auto;
        max-width: ${({ $svgMaxWidth }) => {
            if ($svgMaxWidth) {
                if (typeof $svgMaxWidth === 'number') {
                    return `${$svgMaxWidth}px`;
                }
                return $svgMaxWidth;
            }

            return `50%`;
        }};
        max-height: ${({ $svgMaxHeight }) => {
            if ($svgMaxHeight) {
                if (typeof $svgMaxHeight === 'number') {
                    return `${$svgMaxHeight}px`;
                }
                return $svgMaxHeight;
            }

            return `50%`;
        }};

        /* Safari needs this. */
        flex-grow: 1;
    }

    ${({ $loading, $backgroundColour }) => $loading ? `background: ${$backgroundColour};` : `
        @media (hover: hover) {
            :hover {
                background: ${$backgroundColour};
            }
        }

        :focus-visible {
            background: ${$backgroundColour};
        }
    `}

    [disabled],
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        background: none;
    }
`;

IconButtonContainer.displayName = 'IconButtonContainer';